<template>
  <div v-if="_details.uuid">
    <v-card
      style="width:100%;"
      class="d-flex justify-center"
      v-if="!showMobileView"
    >
      <v-layout
        class="d-flex justify-center align-center pr-4"
        style="height:80px; width: 100%;"
      >
        <div class="d-flex align-center pl-5" style="width:100%; height:80px;">
          <h4
            style="color:gray; padding-right:4px;"
            @click="goBack()"
            class="go-back"
          >
            {{ screenName }} >
          </h4>
          <h4 v-if="currentClient.client_name !== 'shark'">
            {{ _details.device_id }}
          </h4>
          <h4 v-else>
            {{ _details.car_number }}
          </h4>
        </div>
      </v-layout>
    </v-card>
    <v-row class="d-flex flex-wrap justify-space-between ma-0">
      <screen-detail-card />
      <!-- <screen-inventory-management />
      <requests v-if="_details.requests" />
      <ad-campaigns /> -->
      <features v-if="_details.features" />
      <app-usage v-if="_details.appUsageData" />
      <screen-shots v-if="_details.screenShots" />
      <raw-data />
      <screen-locations v-if="_details.coordinates" />
    </v-row>
    <UpdateSnackbar />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import ScreenDetailCard from '@/components/screens/ScreenDetailCard';
// import ScreenInventoryManagement from '@/components/screens/ScreenInventoryManagement';
// import Requests from '@/components/screens/Requests';
import ScreenShots from '@/components/screens/ScreenShots';
import Features from '@/components/screens/Features';
import AppUsage from '@/components/screens/AppUsage';
// import AdCampaigns from '@/components/screens/AdCampaigns';
import ScreenLocations from '@/components/screens/ScreenLocations';
import RawData from '@/components/screens/RawData';
import UpdateSnackbar from '@/components/screens/UpdateSnackbar';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import router from '../router';
import { MobileView } from '@/mixins';

export default {
  components: {
    ScreenDetailCard,
    // ScreenInventoryManagement,
    // Requests,
    // AdCampaigns,
    ScreenShots,
    ScreenLocations,
    RawData,
    Features,
    AppUsage,
    UpdateSnackbar,
  },
  mixins: [MobileView, ScreenDetailData],
  methods: {
    ...mapActions({
      _getDetails: 'screenDetails/acquireDetails',
      _updateDetails: 'screenDetails/uploadDetails',
    }),
    ...mapMutations({
      _setDetails: 'screenDetails/setDetails',
    }),
    goBack() {
      router.push(
        `/${this.currentClient.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/screens`
      );
    },
  },
  computed: {
    ...mapGetters({
      _details: 'screenDetails/getDetails',
      currentClient: 'account/getCurrentClient',
      _clientIsSet: 'account/getClientIsSet',
      _updateInProgress: 'screenDetails/getUpdateInProgress',
    }),
    details: {
      get() {
        return this._details;
      },
      set(val) {
        this._setDetails(val);
      },
    },
    screenName() {
      if (this.currentClient.client_name === 'shark') {
        return 'Golf Car';
      }
      return 'Screen';
    },
  },
  watch: {
    _clientIsSet() {
      if (this._clientIsSet) {
        this._getDetails(this.$route.params.id);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this._clientIsSet) {
      this._getDetails(this.$route.params.id);
    }
    this.editable = false;
  },
};
</script>

<style>
.go-back:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
